import { ReactNode } from 'react'
import {
  LayoutWithTitleAndInfo,
  LayoutWithTitleAndInfoProps,
  PageLayout
} from '..'

interface PageLayoutWithTitleAndInfoProps extends LayoutWithTitleAndInfoProps {
  topElement?: ReactNode
}

export const PageLayoutWithTitleAndInfo = ({
  topElement,
  ...props
}: PageLayoutWithTitleAndInfoProps) => {
  return (
    <PageLayout>
      {topElement}
      <LayoutWithTitleAndInfo addTopPadding={!topElement} {...props} />
    </PageLayout>
  )
}
